import SellOutlinedIcon from '@mui/icons-material/SellOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import VideosSection from './videos-section';
import { VideoType } from './videos-section/source';

const options = [
  {
    value: 'buyer',
    title: 'Watch Buyers Flow',
    icon: ShoppingCartOutlinedIcon,
  },
  {
    value: 'seller',
    title: 'Watch Sellers Flow',
    icon: SellOutlinedIcon,
  },
];

const HowItWorks = () => {
  const [selectedOption, setSelectedOption] = React.useState(options[0]);

  return (
    <Box my={3} px={2} py={6} style={{ position: 'relative' }}>
      <Box
        sx={{
          width: {
            xs: 'calc(100% - 10px)',
            lg: 'calc(100% - 100px)',
          },
          height: '60%',
          mx: 'auto',
          borderRadius: { xs: '12px', lg: '24px' },
          position: 'absolute',
          top: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: '#005FCC',
          backgroundImage: `url("/assets/images/home/gradient.png")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          zIndex: 1,
        }}
      ></Box>

      <Box sx={{ position: 'relative', zIndex: 2 }}>
        <Typography
          color='#fff'
          fontWeight={600}
          fontSize={{ xs: 26, lg: 44 }}
          textAlign={'center'}
          px={2}
          mb={2}
          lineHeight={1}
          component='h2'
        >
          See It in Action
        </Typography>
        <Typography
          color='#EFF6FF'
          lineHeight={1.5}
          fontSize={{ xs: 12, lg: 16 }}
          fontWeight={400}
          textAlign={'center'}
          maxWidth={'600px'}
          mx={'auto'}
          mb={2}
          px={2}
        >
          Watch how buyers streamline purchasing and sellers accelerate fulfillment using our platform.
        </Typography>

        <Box
          sx={{
            maxWidth: 'fit-content',
            mx: 'auto',
            backgroundColor: '#003C83',
            borderRadius: '20px',
            p: 1,
          }}
          display={'flex'}
          gap={1}
          mb={2.5}
        >
          {options.map(opt => {
            const isSelected = opt.value === selectedOption.value;

            return (
              <Button
                type='button'
                onClick={() => {
                  if (!isSelected) {
                    setSelectedOption(opt);
                  }
                }}
                startIcon={<opt.icon />}
                sx={{
                  borderRadius: '10px',
                  px: 2,
                  py: 2.5,
                  lineHeight: 1.25,
                  color: isSelected ? '#1B425D' : '#fff',
                  fontWeight: isSelected ? 800 : 400,
                  fontSize: { sm: 12, lg: 15 },
                  backgroundColor: isSelected ? '#fff' : 'transparent',
                  '&:hover': {
                    backgroundColor: isSelected ? '#fff' : 'transparent',
                  },
                }}
              >
                {opt.title}
              </Button>
            );
          })}
        </Box>

        <Box
          sx={{
            mx: 'auto',
            width: { xs: 'calc(100% - 10px)', lg: 'calc(100% - 100px)' },
            borderRadius: { xs: '12px', lg: '24px' },
          }}
        >
          <VideosSection selectedOption={selectedOption.value as VideoType} />
        </Box>

      </Box>
    </Box>
  );
};

export default HowItWorks;